// Countdown timer for the added-value section (48h from first visit)

function initAvCountdown() {
  const el = document.getElementById("av-countdown");
  if (!el) return;

  const STORAGE_KEY = "av_countdown_end";
  const hours = parseInt(el.dataset.hours || "48", 10);
  const fallbackEndTime = Date.now() + hours * 60 * 60 * 1000;

  function readStoredEndTime() {
    try {
      const rawValue = window.localStorage.getItem(STORAGE_KEY);
      const parsedValue = parseInt(rawValue || "", 10);
      return Number.isFinite(parsedValue) ? parsedValue : null;
    } catch (_) {
      return null;
    }
  }

  function persistEndTime(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(value));
    } catch (_) {
      // Keep the countdown usable even when storage is unavailable.
    }
  }

  let endTime = readStoredEndTime();
  if (!endTime) {
    endTime = fallbackEndTime;
    persistEndTime(endTime);
  }

  const hrsEl = document.getElementById("av-cd-hrs");
  const minEl = document.getElementById("av-cd-min");
  const secEl = document.getElementById("av-cd-sec");
  if (!hrsEl || !minEl || !secEl) return;

  function pad(n) { return String(n).padStart(2, "0"); }

  function tick() {
    const remaining = Math.max(0, endTime - Date.now());
    const totalSec = Math.floor(remaining / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;

    hrsEl.textContent = pad(h);
    minEl.textContent = pad(m);
    secEl.textContent = pad(s);

    if (remaining <= 0) clearInterval(timer);
  }

  tick();
  const timer = setInterval(tick, 1000);
}

document.addEventListener("turbo:load", initAvCountdown);
if (document.readyState !== "loading") initAvCountdown();
